<template>
  <!-- 新版loading -->
  <div class='scontainer'>
    <svg xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         style="margin:auto;display:block;"
         :width="`${boxSize[0]}px`"
         :height="`${boxSize[1]}px`"
         viewBox="0 0 100 100"
         preserveAspectRatio="xMidYMid">
      <g transform="translate(82,50)">
        <g transform="rotate(0)">
          <circle cx="0"
                  cy="0"
                  :r="radio"
                  fill="#61C5E4"
                  fill-opacity="1"
                  transform="scale(1.06912 1.06912)">
            <animateTransform attributeName="transform"
                              type="scale"
                              begin="-0.75s"
                              values="1.3 1.3;1 1"
                              keyTimes="0;1"
                              dur="1s"
                              repeatCount="indefinite"></animateTransform>
            <animate attributeName="fill-opacity"
                     keyTimes="0;1"
                     dur="1s"
                     repeatCount="indefinite"
                     values="1;0"
                     begin="-0.75s"></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(50,82)">
        <g transform="rotate(90)">
          <circle cx="0"
                  cy="0"
                  :r="radio"
                  fill="#B0E2F1"
                  fill-opacity="0.75"
                  transform="scale(1.14412 1.14412)">
            <animateTransform attributeName="transform"
                              type="scale"
                              begin="-0.5s"
                              values="1.3 1.3;1 1"
                              keyTimes="0;1"
                              dur="1s"
                              repeatCount="indefinite"></animateTransform>
            <animate attributeName="fill-opacity"
                     keyTimes="0;1"
                     dur="1s"
                     repeatCount="indefinite"
                     values="1;0"
                     begin="-0.5s"></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(18,50.00000000000001)">
        <g transform="rotate(180)">
          <circle cx="0"
                  cy="0"
                  :r="radio"
                  fill="#B0E2F1"
                  fill-opacity="0.5"
                  transform="scale(1.21912 1.21912)">
            <animateTransform attributeName="transform"
                              type="scale"
                              begin="-0.25s"
                              values="1.3 1.3;1 1"
                              keyTimes="0;1"
                              dur="1s"
                              repeatCount="indefinite"></animateTransform>
            <animate attributeName="fill-opacity"
                     keyTimes="0;1"
                     dur="1s"
                     repeatCount="indefinite"
                     values="1;0"
                     begin="-0.25s"></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(49.99999999999999,18)">
        <g transform="rotate(270)">
          <circle cx="0"
                  cy="0"
                  :r="radio"
                  fill="#CFEDF6"
                  fill-opacity="0.25"
                  transform="scale(1.29412 1.29412)">
            <animateTransform attributeName="transform"
                              type="scale"
                              begin="0s"
                              values="1.3 1.3;1 1"
                              keyTimes="0;1"
                              dur="1s"
                              repeatCount="indefinite"></animateTransform>
            <animate attributeName="fill-opacity"
                     keyTimes="0;1"
                     dur="1s"
                     repeatCount="indefinite"
                     values="1;0"
                     begin="0s"></animate>
          </circle>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'loading',
  components: {},
  props: {
    boxSize: {
      default: () => [60, 60]
    },
    radio: {
      default: 10
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreat() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang='scss' scoped>
.container {
  .main {
    margin: 0;
  }
}
</style>
